<template>
  <div class="auditLoggings">
    <auditLoggingsList ref="list"></auditLoggingsList>
    <router-view @list-reload="listReload" />
  </div>
</template>

<script>
import auditLoggingsList from './auditLoggingsList.vue'

export default {
  components: {
    auditLoggingsList
  },
  methods: {
    async listReload() {
      await this.$refs.list.reload()
    }
  }
}
</script>
<style scoped>
.auditLoggings {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/auditLoggings/auditLoggings.vue